/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import { getProjects, getProject, printProject, createProjects, updateProjects, deleteProjects } from "Modules/projects/config/api.projects";

const state = {
    page: {},
    form: {},
    projects: [],
    project_options: [],
    selectedProject: {
        project_id: null,
        company_id: "",
        project_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        project_details: [],
    },
    projects_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_projects: {
        project_id: {
            name: "project_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        project_name: {
            name: "project_name",
            rules: "trim|max_length[255]|required",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        serial_number: {
            name: "serial_number",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        model: {
            name: "model",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        manufacture_date: {
            name: "manufacture_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        contact_name: {
            name: "contact_name",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        contact_email: {
            name: "contact_email",
            rules: "trim|max_length[255]|valid_email",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        contact_phone: {
            name: "contact_phone",
            rules: "trim|max_length[18]",
            max_len: "18",
            min_len: "",
            default_value: "",
        },
        start_date: {
            name: "start_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        end_date: {
            name: "end_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        po_issue_date: {
            name: "po_issue_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        po_received_date: {
            name: "po_received_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        customer_po: {
            name: "customer_po",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        notes: {
            name: "notes",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    projects: (state) => {
        return state.projects;
    },
};

// actions
const actions = {
    async fetchProjects({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getProjects({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "project_options",
                        with: response.data.projects,
                    });
                } else {
                    commit("mutate", {
                        property: "projects",
                        with: response.data.projects,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchProject({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getProject(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedProject",
                    with: response.data.project,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printProject({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printProject(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveProject({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["project_id"] === "undefined" || body["project_id"] == null || body["project_id"] == "") {
                delete body["project_id"];
                response = await createProjects({ body: body, headers: config.headers });
            } else {
                let project_id = body["project_id"];
                delete body["project_id"];
                response = await updateProjects({ body: body, headers: config.headers }, project_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteProject({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteProjects(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    resetProjects(state) {
        // take the state values and set them back to default except for the rules_
        state.page = {};
        state.form = {};
        state.projects = [];
        state.project_options = [];
        state.selectedProject = {
            project_id: null,
            company_id: "",
            project_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            project_details: [],
        };
        state.projects_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
